"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Colors = {
  // UI Colors

  /** Brand Orange */
  orange: '#ec691a',
  warningRed: '#ee1b34',
  acceptGreen: '#009900',
  optimizerBlue: '#5890de',
  black: '#222222',
  textElementGrey: '#414141',
  secondaryGrey: '#a0a0a0',
  lightGrey: '#e0e0e0',
  lightestGrey: '#f5f5f5',
  white: '#ffffff',
  // BallPlayerColors
  ballPlayerOrange: '#ec691a',
  ballPlayerDarkGreen: '#188518',
  ballPlayerLightGreen: '#4caf50',
  ballPlayerMint: '#009688',
  ballPlayerLightBlue: '#5ac8fa',
  ballPlayerBLue: '#007aff',
  ballPlayerPurple: '#9c27b0',
  ballPlayerRed: '#c00219',
  ballPlayerLightRed: '#ff2d55',
  ballPlayerYellow: '#fe9800',
  ballPlayerBrowm: '#714333',
  // Not part of UI Team Colors.
  warning: '#d0021b',
  tertiaryGrey: '#717171'
};
var _default = Colors;
exports.default = _default;